export default __webpack_public_path__ + "images/bo-1155c3da4861424ea8ffa53c51854847.svg";